import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../services/axiosInstance";
import * as StorageManager from "../utils/StorageManager";
import constants from "../constants";
import * as ipoActions from "../action/ipo";
import * as ipoSelectors from "../selectors/ipo";

export const withIpoConfig = (WrappedComponent) => {
  function WithIpoConfig(props) {
    const ipoConfig = useSelector((state) =>
      ipoSelectors.getIpoConfigData(state),
    );

    const dispatch = useDispatch();
    const [token, setToken] = useState(null);
    useEffect(() => {
      StorageManager.retrieveToken(constants.AUTH_TOKEN).then((value) => {
        setToken(value);
      });
    }, []);

    const { isLoading, data, refetch, isFetched, isRefetching } = useQuery({
      queryKey: ["ipo-config-data", { token: token }],
      queryFn: async () => {
        try {
          return await axiosInstance.get(`/clientarea/ipo/config`);
        } catch (e) {
          return Promise.reject(e);
        }
      },
      retryDelay: 15000,
      enabled: !_.isEmpty(token) && _.isEmpty(ipoConfig),
      gcTime: 0, // don't store in cache
      staleTime: 0,
    });
    useEffect(() => {
      if (!isRefetching) {
        dispatch(ipoActions.setIpoConfig(data));
      }
    }, [data, isRefetching]);

    useEffect(() => {
      if (_.isEmpty(ipoConfig) && isFetched && !isRefetching) {
        refetch().then((r) => console.log("r", r));
      }
    }, [ipoConfig]);

    return (
      <WrappedComponent
        {...props}
        loading={isLoading}
        ipoConfig={ipoConfig}
        refetch={refetch}
      />
    );
  }

  return WithIpoConfig;
};
